import { InjectionToken, Provider } from '@angular/core';

export type SupportedDeviceCategoriesConfig = {
	[category: string]: unknown;
};

export const DEVICE_CATEGORIES_CONFIG = new InjectionToken<SupportedDeviceCategoriesConfig>(
	'DEVICE_CATEGORIES_CONFIG',
	{
		factory: (): SupportedDeviceCategoriesConfig => ({})
	}
);

export function provideSupportedDeviceCategoriesConfig(config: Partial<SupportedDeviceCategoriesConfig>): Provider {
	return {
		provide: DEVICE_CATEGORIES_CONFIG,
		useValue: { ...config }
	};
}
